import React, { Component } from 'react';
import { connect } from 'react-redux';
import {InputText} from 'primereact/inputtext';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {Link} from 'react-router-dom';
import {Button} from 'primereact/button';
import { DATATABLE_CONFIG, POSITION_SUBMENU_ID } from '../../../shared/Config';
import { HASACCESS } from '../../../shared/utility';
import {Toast} from 'primereact/toast';
import Messages from '../../../shared/UI/Messages/Messages';
import * as actions from '../../../store/actions/index';


class PositionMaster extends Component {
    state = {
        selectedValue:[]
    }

    componentDidMount(){        
        this.props.getMasterTableList('GetPosition');    
        this.getAccess = HASACCESS(POSITION_SUBMENU_ID);
    }

   

    actionTemplate = (rowData) => {
        return <div className="actionCenter">
            {(this.getAccess!==undefined && this.getAccess.editAccess!== false) &&
            <Link to={"/position/edit/"+rowData.positionId}><Button type="button" icon="pi pi-pencil" className="p-button-info" ></Button></Link>
            }
            {(this.getAccess!==undefined && this.getAccess.viewAccess!== false) &&
            <Link to={"/position/view/"+rowData.positionId}><Button type="button" icon="pi pi-eye" className="p-button-secondary" ></Button></Link>
            }
            </div>;
    }
    
   
    renderPosNo = (rowData) => {
        let reportedTo = rowData.reportedTo;
        let result = '';
        if(this.props.tableLists.positionList !== undefined){
            result =  this.props.tableLists.positionList.filter(list => {
                return list.positionId === reportedTo;
            }).reduce((_,el) => {
                return el.positionNo
            },'');
        }
        return result;
    }
  
    renderPosName = (rowData) => {
        let reportedTo = rowData.reportedTo;
        let result = '';
        if(this.props.tableLists.positionList !== undefined){
            result =  this.props.tableLists.positionList.filter(list => {
                return list.positionId === reportedTo;
            }).reduce((_,el) => {
                return el.name
            },'');
        }
        return result;
    }
 
    delete = () => {
        if(this.state.selectedValue.length > 0){
            const updatedValue = this.state.selectedValue.map( value => {
                return { DeleteID : value.positionId};
            });    
            this.props.dynamicDeleteProcess('position',updatedValue,'GetPosition');
            this.setState({selectedValue:[]});
        }else{
            this.growl.show({severity: 'error', summary: null, detail: 'Please select atleast one checkbox'});
        }
    }

  
    render() {   
        

        if(this.getAccess!==undefined && this.getAccess.viewAccess === false){
            this.props.history.push('/dashboard');
        }

        let tableData = [];
        if(this.props.tableLists.positionList !== undefined){
            tableData = this.props.tableLists.positionList;
        }

        const header = (
            <div style={{'textAlign':'right'}}>
                <InputText type="search" onInput={(e) => this.setState({globalFilter: e.target.value})} placeholder="Search..." />
            </div>
        );


        return (
            <div className="p-grid padding">
                { this.props.loading && <div className="page-loader"></div>}
                { this.props.error !== null && <Messages type="error" message={this.props.error}/>}
                <Toast ref={(el) => this.growl = el} />
                <div className="p-col-12">
                    <div className="card card-w-title" style={{position:'relative'}}>
                        <h1>Position</h1>
               
                        <div className="p-grid">
                           

                            <div className="p-col-12 p-lg-12">
                                <div className="mt1">
                                {(this.getAccess!==undefined && this.getAccess.addAccess!== false) && 
                                 <Link to="/position/add/new"><Button style={{float: 'right'}} label="Add Position" className="ml1"  icon="pi pi-plus"  /></Link>
                                }

                                {(this.getAccess!==undefined && this.getAccess.deleteAccess!== false) &&
                                 <Button  style={{float: 'right'}} onClick={this.delete} label="Delete" icon="pi pi-trash"  className="p-button-danger"/>
                                }
                                </div>                                
                            </div>
                      
                            					 	
                        <div className="p-col-12" style={{marginTop:'2em'}}>
                     
                       
                        <DataTable value={tableData}
                         selection={this.state.selectedValue} onSelectionChange={e => this.setState({selectedValue: e.value})}
                         globalFilter={this.state.globalFilter}  header={header} {...DATATABLE_CONFIG}>
                                <Column selectionMode="multiple" style={{width:'3em'}}/>
                                <Column field="positionNo" header="Position No" sortable={true} />
                                <Column field="name" header="Position Name" />
                                <Column field="reportedTo" header="Reporting To Position No" body={this.renderPosNo}/>
                                <Column field="reportedTo" header="Reporting To Position Name" body={this.renderPosName} />
                                <Column field="action" body={this.actionTemplate} header="Action"/>
                            </DataTable>
                        </div>
                        </div>

                    </div>
                </div>
            </div>
        );
    }
}



const mapStateToProps = state => {
    return{
        loggedUserDetail : state.auth.userObject,
        loading : state.master.loading,
        error : state.master.error,
        success: state.master.success,
        tableLists : state.master.tableLists
    }
}
  
const mapDispatchToProps = dispatch => {
    return{
        dynamicDeleteProcess: (model,data,func) => dispatch(actions.dynamicDeleteProcess(model,data,func)),
        getMasterTableList: (table) => dispatch(actions.getMasterTableList(table)),
    }
}

  
export default connect(mapStateToProps,mapDispatchToProps)(PositionMaster);